const slugify = (value) => {
  return String(value || "file")
    .toLowerCase()
    .trim()
    .replace(/\.[a-z0-9]+$/i, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "file";
};

const formatDateParts = (date) => {
  const pad = (num) => String(num).padStart(2, "0");
  return {
    yyyy: date.getFullYear(),
    mm: pad(date.getMonth() + 1),
    dd: pad(date.getDate()),
    hh: pad(date.getHours()),
    min: pad(date.getMinutes()),
  };
};

const getExtension = (value, fallback = "pdf") => {
  const match = String(value || "").trim().match(/\.([a-z0-9]+)$/i);
  return match ? match[1].toLowerCase() : fallback;
};

export const getFileName = (rawName) => {
  const now = new Date();
  const { yyyy, mm, dd, hh, min } = formatDateParts(now);
  const slug = slugify(rawName);
  const extension = getExtension(rawName);

  return `transocean-${slug}-${yyyy}-${mm}-${dd}-${hh}-${min}.${extension}`;
};
